<template>
  <div class="nv-page">
    <div class="nv-login">
      <!-- Bilgi Paneli -->
      <aside class="nv-login__aside">
        <span class="nv-login__badge">
          <v-icon small color="white">mdi-shield-key-outline</v-icon>
          Güvenli Giriş
        </span>
        <h2>Akıllı kartınız ile birkaç adımda giriş yapın</h2>
        <p>
          İmzalama işlemleri için öncelikle akıllı kartınızla (e-İmza / Mali Mühür) giriş yapmanız gerekmektedir.
        </p>
        <ol class="nv-login__steps">
          <li :class="{'is-done': !!SelectedItem.terminal}">
            <span class="nv-login__step-num">
              <v-icon v-if="SelectedItem.terminal" x-small color="white">mdi-check</v-icon>
              <template v-else>1</template>
            </span>
            Akıllı kart okuyucunuzu seçin
          </li>
          <li :class="{'is-done': certificationsStatus}">
            <span class="nv-login__step-num">
              <v-icon v-if="certificationsStatus" x-small color="white">mdi-check</v-icon>
              <template v-else>2</template>
            </span>
            PIN kodunuzu girerek giriş yapın
          </li>
          <li>
            <span class="nv-login__step-num">3</span>
            Sertifikanızı seçip devam edin
          </li>
        </ol>
      </aside>

      <!-- Giriş Formu -->
      <div class="nv-login__form">
        <h3 class="nv-login__title">Giriş Yap</h3>
        <p class="nv-login__subtitle">Kartınızın bilgisayarınıza takılı olduğundan emin olunuz.</p>

        <label class="nv-label">Akıllı Kart Okuyucu</label>
        <div class="d-flex align-center">
          <v-select
              class="nv-field flex-grow-1"
              outlined
              v-model="SelectedItem.terminal"
              :items="getSlots"
              item-text="SlotName"
              placeholder="Akıllı Kart Okuyucu Seçiniz."
              no-data-text="Akıllı Kart Okuyucu Bulunamadı"
              prepend-inner-icon="mdi-credit-card-scan"
              :menu-props="{bottom:true,offsetY:true}"
              dense
              hide-details>
          </v-select>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                  v-bind="attrs"
                  v-on="on"
                  :loading="slotRefreshLoading"
                  :disabled="slotRefreshLoading"
                  outlined
                  color="primary"
                  class="nv-btn nv-btn--icon ml-2"
                  aria-label="Kart okuyucuları yenile"
                  @click="GetSlotsRefresh()">
                <v-icon>mdi-autorenew</v-icon>
              </v-btn>
            </template>
            <span class="font-size-sm">Kart Okuyucuları Yenile</span>
          </v-tooltip>
        </div>

        <label class="nv-label mt-5">PIN Kodu</label>
        <v-text-field
            class="nv-field"
            outlined
            :append-icon="passIconShow ? 'mdi-eye' : 'mdi-eye-off'"
            :type="passIconShow ? 'text' : 'password'"
            @click:append="passIconShow = !passIconShow"
            prepend-inner-icon="mdi-lock-outline"
            dense
            hide-details
            v-model="SelectedItem.pinCode"
            placeholder="PIN kodunuzu giriniz"
            autocomplete="off"
            @keyup.enter="ActivationLogin()">
        </v-text-field>

        <v-btn
            :loading="loginLoading"
            :disabled="loginLoading"
            :outlined="certificationsStatus"
            color="primary"
            depressed
            block
            large
            class="nv-btn mt-5"
            @click="ActivationLogin()">
          <v-icon small left>mdi-login</v-icon>
          Giriş Yap
        </v-btn>

        <v-expand-transition>
          <div v-if="certificationsStatus" class="nv-login__certificate">
            <div class="nv-divider-text"><span>Sertifika Seçimi</span></div>
            <v-select
                class="nv-field"
                outlined
                v-model="selectedCertificate"
                :items="certifications"
                item-text="CommonName"
                item-value="Index"
                placeholder="Sertifika Seçimi Yapınız."
                no-data-text="Sertifika Bulunamadı"
                prepend-inner-icon="mdi-certificate"
                :menu-props="{bottom:true,offsetY:true}"
                return-object
                dense
                hide-details>
            </v-select>
            <div v-if="selectedCertificate" class="nv-cert-expiry" :class="'nv-cert-expiry--' + certificateExpiryState">
              <v-icon small>{{ certificateExpiryState === 'ok' ? 'mdi-calendar-check-outline' : 'mdi-calendar-alert' }}</v-icon>
              <span>
                Sertifika Bitiş Tarihi: <b>{{ new Date(selectedCertificate.ExpiryDate).toLocaleString('tr') }}</b>
                <template v-if="certificateExpiryState === 'expired'"> (Süresi dolmuş)</template>
                <template v-else-if="certificateExpiryState === 'soon'"> (Süresi yakında dolacak)</template>
              </span>
            </div>
            <v-btn
                :loading="selectLoading"
                :disabled="selectLoading"
                color="secondary"
                depressed
                block
                large
                class="nv-btn mt-4"
                @click="ActiveCertificate()">
              Seçilen Sertifika İle Devam Et
              <v-icon small right>mdi-arrow-right</v-icon>
            </v-btn>
          </div>
        </v-expand-transition>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import action from "@/core/services/WebSocket/action";
import {
  GET_ACCOUNT,
  GET_CREATION,
  GET_SELECTED_CERTIFICATE,
  GET_SLOTS,
  GET_TOKEN
} from "@/core/services/store/profile.module";
import token from "@/core/services/Token/action"
import activation from "@/core/services/Activation/action"
import {AxiosRedirect} from "../../../core/services/axios.redirect"

export default {
  name: "Login",
  data() {
    return {
      passIconShow: false,
      loginLoading: false,
      slotRefreshLoading: false,
      SelectedItem: {
        terminal: null,
        pinCode: null
      },
      selectLoading: false,
      certifications: [],
      certificationsStatus: false,
      selectedCertificate: null,
    }
  },
  methods: {
    toastError(error) {
      this.$bvToast.toast(error, {
        toaster: 'b-toaster-bottom-right',
        title: 'Hata',
        variant: 'danger',
        solid: true,
        autoHideDelay: 3000,
        bodyClass: "toastError-body",
        headerClass: "toastError-header",
        toastClass: "toastError-container"
      });
    },
    async GetSlotsRefresh() {
      this.slotRefreshLoading = true
      let response = await action.CheckConnetion();
      if (response && response.status == 200) {
        let slot = await action.GetSlots()
        if (slot.status == 200) {
          await this.$store.dispatch(GET_SLOTS, slot.data)
          this.SelectedItem.terminal = slot.data.length > 0 ? this.getSlots[0].SlotName : null
        } else {
          response.data.Errors ? response.data.Errors.forEach((error) => {
            this.toastError(error)
          }) : this.toastError("Soketler Getirilirken Hata.");
        }
      } else {
        if (response && response.data.Errors) {
          response.data.Errors.forEach((error) => {
            this.toastError(error)
          })
        } else {
          this.toastError("Bağlantı Başarısız.");
          setTimeout(() => {
            this.$router.push("/")
          }, 1000)
        }

      }
      this.slotRefreshLoading = false
    },
    async ActivationLogin() {
      this.certificationsStatus = false
      if (!this.SelectedItem.terminal || !this.SelectedItem.pinCode) this.toastError("Bilgiler Eksiksiz Girilmelidir.")
      else {
        this.loginLoading = true
        let response = await action.GetCertificate(this.SelectedItem)
        if (response) {
          if (response && response.status == 200) {
            this.certifications = response.data.sort((a, b) => b.Index - a.Index);
            this.certificationsStatus = true;
            this.selectedCertificate = this.certifications[0];
          } else {
            response.data.Errors ? response.data.Errors.forEach((error) => {
              this.toastError(error)
            }) : this.toastError("Aktivasyon Girişi Yapılırken Hata.");
          }
        } else {
          this.toastError("Web Socket Uygulamasını Kontrol Ediniz.")
        }
        this.loginLoading = false
      }
    },
    async ActiveCertificate() {
      await this.$store.dispatch(GET_CREATION, {})
      this.selectLoading = true
      await this.$store.dispatch(GET_SELECTED_CERTIFICATE, this.selectedCertificate)

      let _URL = AxiosRedirect()

      const params = new URLSearchParams();
      params.append('client_id', _URL.clientID)
      params.append('client_secret', _URL.clientSecret)
      params.append('grant_type', _URL.grantType)
      params.append('scope', _URL.scope)

      let response = await token.CreateToken(params)
      if (response && response.status == 200) {
        await this.$store.dispatch(GET_TOKEN, response.data)
        let certificate = this.getCertificate
        let Info = await activation.AccountInfo(certificate.SerialNumber)
        await this.$store.dispatch(GET_ACCOUNT, Info.data)
        if (Info.status == 200) {

          if (Info.data.IsExist) {
            this.selectLoading = false
            this.$router.push("/dashboard")
          } else {
            this.selectLoading = false
            this.$router.push("/create")
          }

        } else {
          response.data.Errors ? response.data.Errors.forEach((error) => {
            this.toastError(error)
          }) : this.toastError("Hesap Bilgisi Getirilirken Hata.");
        }

      } else {
        response && response.data.Errors ? response.data.Errors.forEach((error) => {
          this.toastError(error)
        }) : this.toastError("Token Oluşturulurken Hata.");
      }

      this.selectLoading = false
    }
  },
  async created() {
    document.title = 'Nilvera | Aktivasyon Giriş'
    await this.$store.dispatch(GET_ACCOUNT, {})
    this.GetSlotsRefresh()
  },
  computed: {
    ...mapGetters(['getSlots', 'getCertificate', 'getToken']),
    certificateExpiryState() {
      if (!this.selectedCertificate || !this.selectedCertificate.ExpiryDate) return 'ok'
      const expiry = new Date(this.selectedCertificate.ExpiryDate).getTime()
      if (isNaN(expiry)) return 'ok'
      const diff = expiry - Date.now()
      if (diff < 0) return 'expired'
      if (diff < 30 * 24 * 60 * 60 * 1000) return 'soon'
      return 'ok'
    }
  }
}
</script>


